<template>
  <div class="hello" :class="{'hellone':selectedIndex==2 ,'hellotwo':selectedIndex==1,'hellothree':selectedIndex==0}">
	<nav class="navbar">
	      <ul class="nav-list" >
	        <li class="nav-item" v-for="(item,index) in tabList" :key="index">
				<a 
				:href="jumpurl"
				@click.prevent="selectNavItem(index)"
				:class="{ active: selectedIndex === index }">
				{{item.name}}
				</a>
			</li>
	        
	      </ul>
	</nav>
	
	<Contact v-show="selectedIndex==3" @message-from-child="handleMessageFromChild"></Contact>
	<JoinUs v-show="selectedIndex==2"  @message-from-child="handleMessageFromChild"></JoinUs>
	<Company v-show="selectedIndex==1" @message-from-child="handleMessageFromChild"></Company>
	<HelloNovel v-show="selectedIndex==0" @message-from-child="handleMessageFromChild"></HelloNovel>
	<div class="tip" :style="selectedIndex!=3?'position:relative':''">All Rights Reserved. 2024 IREAD CULTURE TECHNOLOGY Inc. ©</div>
  </div>
</template>

<script>
	import Contact from './Contact.vue'
	import JoinUs from './JoinUs.vue'
	import Company from './Company.vue'
	import HelloNovel from './HelloNovel.vue'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }, 
  components: {
    Contact,
	JoinUs,
	Company,
	HelloNovel
  },
  
  data(){
	  return{
		  tabList:[{name:'HelloNovel'},{name:'Company'},{name:'Join us'},{name:'Contact us'},{name:'Stay tuned..'}],
		  jumpurl:'',
		  selectedIndex: 0,
	  }
  },
  
  methods:{
	  selectNavItem(index) {
		    if(index==4){
				return false
			}
	        this.selectedIndex = index
	 },
	 
	 handleMessageFromChild(val){
		 if(val=='HelloNovel'){
			 this.selectedIndex = 0
		 } else if(val == 'Company'){
			 this.selectedIndex = 1
		 } else if(val == 'Author Recruitment'){
			 this.selectedIndex = 2
		 } else if(val == 'Contact Information'){
			 this.selectedIndex = 3
		 }
		 
		 				console.log("22222",this.selectedIndex)
		 
		 window.scrollTo({
		    top: 0,
		    behavior: 'smooth'
		});
	 }
  }
}
</script>

<style  scoped="scoped">
	
	.hello{
		margin: -8px;
		background-image: url('../assets/bg.png');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		background-attachment: fixed;
		min-height: 100vh;
	}
	
	.hellone{
		/* width: 100%; */
		background: url('../assets/bgone.png') center/100% auto no-repeat;
		 /* background-repeat: no-repeat;
		  background-position: center;
		  background-size: contain; */
	}
	
	.hellotwo{
		background: url('../assets/bgtwo.png') center/100% auto no-repeat;
		 background-size: cover;
	}
	
	.hellothree{
		background: url('../assets/bgthree.png') center/100% auto no-repeat;
		 background-size: cover;
	}
	
	
	.navbar {
	  overflow: hidden; 
	}
	
	.nav-list {
	  list-style-type: none; 
	  margin: 0;
	  padding: 0;
	  display: flex;
	  justify-content: center; 
	}
	
	.nav-item {
	  float: left; 
	  padding: 20px 30px;
	}
	
	.nav-item a {
	  display: block;
	  color: #4A3F00;
	  font-weight: 500;
	  font-size: 16px;
	  text-align: center;
	  padding: 10px 20px; 
	  text-decoration: none; 
	  /* transition: background-color .3s; */
	}
	
	.nav-item a:hover {
	  /* background-color: #575757; */
	}
	.nav-item a.active {
	  background: #FD9F4B;
	  border-radius: 19px;
	  color: white;
	}
	
	.tip{
		position: fixed;
		bottom: 30px;
		left: 0;
		right: 0;
		margin: auto;
		width: 100%; 
		font-family: Inter, Inter;
		font-weight: 500;
		font-size: 13px;
		color: #64856B;
		z-index: 1000; /* 确保它在大多数其他内容之上 */
	}
</style>
